import { render, staticRenderFns } from "./CustomAvatar.vue?vue&type=template&id=3864ab45&"
import script from "./CustomAvatar.vue?vue&type=script&lang=js&"
export * from "./CustomAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports